import getErrorMessage from "api/get-error-message";
import { useApiUserAuth2faVerify } from "api/user/auth/use-api-user-auth-2fa-verify";
import useLogout from "common/auth/hooks/use-logout";
import { Alert } from "components/alert";
import { Button } from "components/button";
import CardNew from "components/card-new";
import { InputField } from "components/input-field";
import PageWrapper from "components/page-wrapper";
import { AMFLogo } from "icons/amf-logo";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useIntercom } from "react-use-intercom";

import css from "./index.module.scss";

type FormValues = {
  token: string;
};

export const Auth2FARequiredPage = () => {
  const [error, errorSet] = useState("");
  const logout = useLogout();
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm<FormValues>();
  const { mutateAsync: verify2fa, isPending } = useApiUserAuth2faVerify();
  const { showNewMessage } = useIntercom();

  const onSubmitForm = handleSubmit(async (data) => {
    errorSet("");

    try {
      await verify2fa({ token: data.token });
      window.location.reload();
    } catch (e) {
      errorSet(getErrorMessage(e));
    }
  });

  return (
    <PageWrapper
      centerVertically
      maxWidth={400}
      title="Two-Factor Authentication (2FA)"
    >
      <CardNew className={css.wrapper}>
        <AMFLogo className={css.logo} />
        <strong className={css.title}>
          Enter the code from your Authenticator App to continue.
        </strong>
        <form className={css.form} onSubmit={onSubmitForm}>
          {error && <Alert type="error">{error}</Alert>}
          <InputField
            {...register("token", { required: "Token is required." })}
            autoComplete="one-time-code"
            autoFocus
            inputMode="numeric"
            isAutoCorrect={false}
            placeholder="123456"
            size="large"
            state={errors.token ? "error" : undefined}
            stateMessage={errors.token?.message}
          />
          <Button loading={isPending} type="submit">
            Verify code
          </Button>
        </form>
        <div className={css.help}>
          Need help?
          <br />
          <a onClick={() => showNewMessage()}>Contact Support</a> or{" "}
          <a onClick={() => logout()}>Logout</a>.
        </div>
      </CardNew>
    </PageWrapper>
  );
};
